import { useEffect, useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import ControlPlanes from "./ControlPlanes";
import { useNavigate, useParams } from "react-router-dom";

// The tab chain is stretched to the viewport so the grid inside a panel can
// claim whatever height is left below the tab list.
const fillHeight = {
  mainBox: {
    ...tabbedDataGridPage.mainBox,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  tabContainer: {
    ...tabbedDataGridPage.tabContainer,
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  tabPanel: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    paddingLeft: "4px",
    // `display: flex` above would override the browser's [hidden] rule and
    // make the inactive panel claim flex space — keep it collapsed.
    "&[hidden]": { display: "none" },
  },
};

const TessellGcpControlPlanes = () => {
  const [selectedTab, setSelectedTab] = useState("dev");
  const navigate = useNavigate();
  const { deploymentStage } = useParams();

  useEffect(() => {
    setSelectedTab(deploymentStage);
  }, [deploymentStage]);

  const tabs = ["dev", "qa", "stage", "prod"];
  return (
    <Box sx={fillHeight.mainBox}>
      <Box sx={fillHeight.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => {
                navigate(
                  `/apps/tessellgcp/deployments/${newValue}/control-planes`,
                  {
                    state: { dp: newValue },
                  }
                );
              }}
              sx={tabbedDataGridPage.tabList}
            >
              {tabs.map((tab, i) => (
                <Tab
                  key={i}
                  label={tab}
                  value={tab}
                  icon={<></>}
                  iconPosition="end"
                ></Tab>
              ))}
            </TabList>
          </Box>
          {tabs.map((tab, i) => (
            <TabPanel key={i} value={tab} sx={fillHeight.tabPanel}>
              <ControlPlanes />
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default TessellGcpControlPlanes;
